var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "team-list-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Teams")]), _vm.loading ? _c('div', {
    staticClass: "loading-spinner"
  }, [_c('p', [_vm._v("Loading teams...")])]) : _vm.teams.length === 0 ? _c('div', {
    staticClass: "no-teams"
  }, [_c('p', [_vm._v("No teams available at the moment.")])]) : _c('div', {
    staticClass: "row"
  }, _vm._l(_vm.teams, function (team) {
    return _c('div', {
      key: team.teamId,
      staticClass: "col-md-4 col-sm-6 mb-4"
    }, [_c('a', {
      staticClass: "team-card-link",
      attrs: {
        "href": ((_vm.teamDetailBaseUrl) + "/" + (team.teamId)),
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('div', {
      staticClass: "team-card"
    }, [_c('div', {
      staticClass: "team-image"
    }, [_c('img', {
      attrs: {
        "src": team.logo || _vm.defaultImage,
        "alt": team.teamName
      },
      on: {
        "error": _vm.handleImageError
      }
    })]), _c('div', {
      staticClass: "team-content"
    }, [_c('h3', [_vm._v(_vm._s(team.teamName))]), _c('p', {
      staticClass: "team-description"
    }, [_vm._v(_vm._s(team.teamDescription))]), _c('div', {
      staticClass: "team-meta"
    }, [_c('span', {
      staticClass: "member-count"
    }, [_c('i', {
      staticClass: "fa fa-users"
    }), _vm._v(" " + _vm._s(_vm.getMemberCount(team)) + " Members ")])])])])])]);
  }), 0), _vm.pagination.lastPage > 1 ? _c('div', {
    staticClass: "pagination-wrap"
  }, [_c('nav', [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.pagination.currentPage === 1
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.pagination.currentPage - 1);
      }
    }
  }, [_vm._v(" Previous ")])]), _vm._l(_vm.displayPages, function (page) {
    return _c('li', {
      key: page,
      staticClass: "page-item",
      class: {
        active: page === _vm.pagination.currentPage
      }
    }, [_c('a', {
      staticClass: "page-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.changePage(page);
        }
      }
    }, [_vm._v(" " + _vm._s(page) + " ")])]);
  }), _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.pagination.currentPage === _vm.pagination.lastPage
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.pagination.currentPage + 1);
      }
    }
  }, [_vm._v(" Next ")])])], 2)])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }